import { ITableDataSetSection, TableDataSetSection } from './TableDataSetSection';
import { IDataSet } from '../dataset/DataSet';
import { IConfiguration } from '../configuration/Configuration';
import { TableDataSetField } from './TableDataSetField';
import { IConfigurationField } from '../configuration/Field';
import { IConfigurationSection } from '../configuration/Section';

export interface ITableTempDataSetFields {
    identifier: string;
    fields: TableDataSetField[];
}

export class TableTempDataSetFields implements ITableTempDataSetFields {
    public identifier: string;
    public fields: TableDataSetField[];

    constructor();
    // tslint:disable-next-line: unified-signatures
    constructor(obj: ITableTempDataSetFields);
    // tslint:disable-next-line: unified-signatures
    constructor(obj: IConfigurationField);
    // tslint:disable-next-line: unified-signatures
    constructor(obj: IConfigurationSection);
    constructor(obj?: any) {

        this.identifier = obj && obj.identifier ? obj.identifier : '';

        this.fields = [];
        if (obj && obj.fields !== undefined) {
            obj.fields.forEach((field: any) => {
                this.fields.push(new TableDataSetField(field));
            });
        }
    }
}
